import { RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { getExtensionRules } from '../../../shared/all-extension-rules';

export const RestrictionRules = getExtensionRules({
  excludeRules: [
    RuleEntity.BARCODE,
    RuleEntity.VENDOR,
    RuleEntity.COLLECTION,
    RuleEntity.WEIGHT,
    RuleEntity.HAS_DISCOUNT,
    RuleEntity.CART_ATTRIBUTE_KEY,
    RuleEntity.CART_ATTRIBUTE_VALUE,
    RuleEntity.CART_ATTRIBUTE,
  ],
});
